import router from './router'
import store from './stores'

function handleMobile () {
  // 判断是否手机端访问
  let userAgentInfo = navigator.userAgent.toLowerCase()
  let agents = [
    'android',
    'iphone',
    'symbianos',
    'windows phone',
    'ipad',
    'ipod'
  ]
  let isMobile = agents.find(v => userAgentInfo.includes(v))
  store.commit('SET_PC_VALUE', !isMobile)
  if (isMobile) {
    // Ios/Android
    let agentInfo = navigator.userAgent
    let isAndroid = agentInfo.indexOf('Android') > -1 || agentInfo.indexOf('Adr') > -1 // android 终端
    let isiOS = !!agentInfo.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    store.commit('SET_IOS_VALUE', isiOS)
    store.commit('SET_ANDROID_VALUE', isAndroid)
  }
}

function handleCurrentEV () {
  var ua = window.navigator.userAgent.toLowerCase()
  // 判断在哪里面 微信、微博、QQ、QQ浏览器、手机自带浏览器
  if (ua.indexOf('weibo') > -1) {
    // 新浪微博
    store.commit('SET_WX_VALUE', true)
  } else if (ua.indexOf(' qq') > -1) {
    // QQ内置浏览器
    store.commit('SET_WX_VALUE', true)
  } else if (ua.indexOf('micromessenger') > -1) {
    // 微信
    store.commit('SET_WX_VALUE', true)
  } else if (ua.indexOf(' qq') === -1 && ua.indexOf('mqqbrowser') > -1) {
    // QQ浏览器
    store.commit('SET_WX_VALUE', false)
  } else {
    // 系统浏览器
    store.commit('SET_WX_VALUE', false)
  }
}

// 添加路由守卫
router.beforeEach((to, from, next) => {
  handleMobile()
  handleCurrentEV()
  next()
})
